import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = () => api.get("/products").then((r) => r.data.products);
export const getFx = () => api.get("/fx").then((r) => r.data);

export const createCheckout = (product_id, email, promo_code) =>
  api
    .post("/checkout/session", {
      product_id,
      email,
      origin_url: window.location.origin,
      promo_code: promo_code || null,
    })
    .then((r) => r.data);

export const validatePromo = (code) =>
  api.post("/promo/validate", { code }).then((r) => r.data);

export const subscribeNewsletter = (email, name) =>
  api.post("/newsletter", { email, name: name || null }).then((r) => r.data);

export const supportChat = (session_id, message) =>
  api.post("/support/chat", { session_id, message }).then((r) => r.data);

export const supportHistory = (session_id) =>
  api.get(`/support/history/${session_id}`).then((r) => r.data.messages);

export const resendDownload = (email) =>
  api.post("/support/resend-download", { email }).then((r) => r.data);

export const retentionStart = (email) =>
  api.post("/retention/start", { email }).then((r) => r.data);
export const retentionDecline = (session_id) =>
  api.post("/retention/decline", { session_id }).then((r) => r.data);
export const retentionAccept = (session_id) =>
  api.post("/retention/accept", { session_id }).then((r) => r.data);
export const retentionConfirmDeletion = (session_id) =>
  api.post("/retention/confirm-deletion", { session_id, confirmed: true }).then((r) => r.data);
export const retentionRefund = (session_id) =>
  api.post("/retention/refund", { session_id }).then((r) => r.data);

// ---- Admin ----
export const ADMIN_TOKEN_KEY = "pt_admin_token";
export const ADMIN_ROLE_KEY = "pt_admin_role";
const authHeader = () => {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  return t ? { Authorization: `Bearer ${t}` } : {};
};
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const adminStats = () =>
  api.get("/admin/stats", { headers: authHeader() }).then((r) => r.data);
export const adminListRefunds = (status = "pending_processing") =>
  api.get(`/admin/refunds?status=${status}`, { headers: authHeader() }).then((r) => r.data.refunds);
export const adminApproveRefund = (id) =>
  api.post(`/admin/refunds/${id}/approve`, {}, { headers: authHeader() }).then((r) => r.data);
export const adminRejectRefund = (id) =>
  api.post(`/admin/refunds/${id}/reject`, {}, { headers: authHeader() }).then((r) => r.data);
export const adminSendNewsletter = (title, body) =>
  api.post("/admin/newsletter/send", { title, body }, { headers: authHeader() }).then((r) => r.data);
export const adminListUsers = () =>
  api.get("/admin/users", { headers: authHeader() }).then((r) => r.data);
export const adminCreateUser = (email, password, role) =>
  api.post("/admin/users", { email, password, role }, { headers: authHeader() }).then((r) => r.data);
export const adminUpdateRole = (email, role) =>
  api.patch(`/admin/users/${encodeURIComponent(email)}`, { role }, { headers: authHeader() }).then((r) => r.data);
export const adminDeleteUser = (email) =>
  api.delete(`/admin/users/${encodeURIComponent(email)}`, { headers: authHeader() }).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export const downloadUrl = (sessionId) => `${API}/download/${sessionId}`;

export const captureLead = (email) => api.post("/lead", { email }).then((r) => r.data);

export const fullUrl = (path) => `${BACKEND_URL}${path}`;

export const CURRENCIES = ["EUR", "USD", "GBP"];

export const formatFx = (chfAmount, fx) => {
  if (!fx?.rates) return [];
  const symbols = { EUR: "€", USD: "$", GBP: "£" };
  return CURRENCIES.map((c) => ({
    code: c,
    value: `${symbols[c]}${(chfAmount * fx.rates[c]).toFixed(0)}`,
  }));
};
